/**
 * 看圖開口說追蹤鉤子 — 每場景最近一次評分落地 localStorage(P3b → P3c 口說弱點
 * 追蹤鋪路;此檔**只存資料,不做 UI**)。沿用 shadowing-store 模式。
 *
 * 鐵則:純學習側、錄音不上雲(這裡只存分數與關鍵字,不存任何音訊);不碰
 * commanderXp / factionXP 等任何進度數值。
 */

/** localStorage key(單一真相)。 */
export const PICTURE_TALK_STORE_KEY = 'ef.oral.pictalk';

/** 一個場景的最近評分紀錄。 */
export interface PictureTalkRecord {
  /** 0..100 關鍵字覆蓋率百分數。 */
  percent: number;
  /** 還沒說到的場景關鍵字(P3c 弱點分析素材)。 */
  missed: string[];
  /** ISO 時間戳。 */
  at: string;
}

/** 全部紀錄:sceneId → 最近一次評分。 */
export type PictureTalkScores = Record<string, PictureTalkRecord>;

/** 讀出全部看圖開口說評分(壞 JSON / 無資料回空物件,不丟例外)。 */
export function loadPictureTalkScores(
  storage: Pick<Storage, 'getItem'> = localStorage,
): PictureTalkScores {
  try {
    const raw = storage.getItem(PICTURE_TALK_STORE_KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return parsed as PictureTalkScores;
  } catch {
    return {};
  }
}

/**
 * 記一個場景最近評分(覆蓋同場景舊紀錄)。寫入失敗(配額 / 私密模式)靜默吞掉
 * —— 追蹤是輔助,不能弄壞練習流程。
 */
export function recordPictureTalkScore(
  sceneId: string,
  result: { percent: number; missed: string[] },
  storage: Pick<Storage, 'getItem' | 'setItem'> = localStorage,
): void {
  try {
    const all = loadPictureTalkScores(storage);
    all[sceneId] = {
      percent: Math.max(0, Math.min(100, Math.round(result.percent))),
      missed: [...result.missed],
      at: new Date().toISOString(),
    };
    storage.setItem(PICTURE_TALK_STORE_KEY, JSON.stringify(all));
  } catch {
    /* 追蹤失敗不影響練習 */
  }
}
